var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{attrs:{"to":_vm.to,"disabled":_vm.disabled,"tile":_vm.tile,"href":_vm.href}},[_vm._t("contents",null,{"hover":hover}),_vm._v(" "),_c('v-fade-transition',[(hover && (_vm.to || _vm.href))?_c('v-overlay',{attrs:{"absolute":"","color":_vm.color}}):_vm._e()],1)],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }